import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';

import { defaultLocale } from '../config/i18n.config';
import { LocaleProvider } from '../context/localeContext';
import BlogRollPaginated from '../components/BlogRollPaginated';
import Layout from '../components/Layout';
import ReaserchPage from './ResearchPage';

const ResearchPageTemplate = ({ data, pageContext }) => {
  const title = data.researchPage.frontmatter[defaultLocale].title;
  const heroImage = data.researchPage.frontmatter[defaultLocale].image;
  const heroContent = data.researchPage.frontmatter[defaultLocale].hero;
  const researchPublications = data.researchPublications.edges;

  return (
    <LocaleProvider locale={pageContext.locale}>
      <Layout>
        <ReaserchPage
          title={title}
          heroImage={heroImage}
          heroContent={heroContent}
        />
        <BlogRollPaginated
          items={researchPublications}
        />
      </Layout>
    </LocaleProvider>
  );
};

ResearchPageTemplate.propTypes = {
  data: PropTypes.object.isRequired,
};

export default ResearchPageTemplate;

export const researchPageQuery = graphql`
  query ResearchPage($id: String!, $locale: String!) {
    researchPage: markdownRemark(id: { eq: $id }) {
      frontmatter {
        en {
          title
          hero
          image {
            childImageSharp {
              gatsbyImageData(quality: 90, layout: FULL_WIDTH)
            }
          }
        }
        de {
          title
          hero
        }
      }
    }
    researchPublications: allMarkdownRemark(
      sort: { order: DESC, fields: [frontmatter___date] }
      filter: {
        fields: {
          collection: {
            in: ["research-publications", "country-studies", "disinfo-ads"]
          }
          locale: { eq: $locale }
        }
        frontmatter: { title: { ne: "" } }
        rawMarkdownBody: { ne: "" }
      }
    ) {
      edges {
        node {
          ...BlogRollItem
        }
      }
    }
  }
`;
